import { isObject } from 'lodash'

export default {
  name: 'mainTableConfig',

  computed: {
    tableConfig () {
      return {
        tableConfig: {
          apiConfig: {
            get: {
              module: 'road-maintenance',
              route: 'traffic-regulation',
              method: 'get'
            }
          },
          rowClick: (event) => this.showDetails(event),
          search_and_buttons_config: {
            search_field_config: {
              key: 'doc_class',
              placeholder: this.$t('road-maintenance/aggregator.search_by_request_number'),
              appendIcon: 'mdi-magnify'
            },
            newClick: () => this.onNewClick()
          },
          globalStyle: {
            tableRowClasses: 'table-row',
            sideTableContentColClasses: 'table-side-col'
          },
          tableConfig: {
            styles: {
              useFixedHeaderWidth: true,
              headersHeight: '76px',
              dataRowHeight: '64px'
            },
            cellsConfig: {
              source: {
                custom_display_value: (data) => {
                  return data?.source ? this.$t(data.source) : ''
                }
              },
              request_type: {
                custom_display_value: (data) => {
                  return data?.request_type?.description ? this.$t(data.request_type.description) : ''
                }
              },
              processing_entity: {
                custom_display_value: (data) => {
                  return data?.processing_entity ? this.$t(data.processing_entity) : ''
                }
              },
              status: {
                type: 'status',
                custom_display_value: (data) => {
                  if (data && data.status && isObject(data.status)) {
                    return {
                      ...data.status,
                      ...{
                        description: data.status.description ? this.$t(data.status.description) : '-'
                      }
                    }
                  }
                },
                displayValue: 'description',
                colorObjectKey: 'color',
                textColorKey: 'text',
                backgroundColorKey: 'background',
                style: {
                  textAlign: '-webkit-center'
                },
                statusStyle: {
                  textAlign: 'center',
                  borderRadius: '8px',
                  height: '24px',
                  paddingRight: '12px',
                  paddingLeft: '12px',
                  width: 'max-content'
                }
              }
            },
            headers: [
              {
                label: this.$t('fleet/documents/prl_cargo.sr_no'),
                key: 'id',
                style: {
                  width: '100px'
                },
                always_visible: true
              },
              {
                label: this.$t('road-maintenance/aggregator.registration_time'),
                key: 'created_at',
                style: {
                  width: '160px'
                },
                always_visible: true
              },
              {
                label: this.$t('road-maintenance/aggregator.source_of_registration'),
                key: 'source',
                style: {
                  width: '140px'
                }
              },
              {
                label: this.$t('road-maintenance/aggregator.entered'),
                key: 'user',
                style: {
                  width: '150px'
                }
              },
              {
                label: this.$t('road-maintenance/patrol-service.address'),
                key: 'address',
                style: {
                  width: '200px'
                }
              },
              {
                label: this.$t('road-maintenance/aggregator.reason'),
                key: 'type',
                style: {
                  width: '240px'
                }
              },
              {
                label: this.$t('road-maintenance/aggregator.num_streets_being_closed'),
                key: 'streets_closed',
                style: {
                  width: '160px'
                }
              },
              {
                label: this.$t('road-maintenance/aggregator.duration'),
                key: 'duration',
                style: {
                  width: '180px'
                }
              },
              {
                label: this.$t('fleet/vehicle.status'),
                key: 'status',
                style: {
                  width: '200px',
                  textAlign: 'center'
                },
                always_visible: true
              }
            ],
            paginationConfig: {
              perPageOptions: [20, 50, 100],
              perPage: 20,
              currentPage: 1
            },
            actionsConfig: [
              {
                label: this.$t('base.edit'),
                icon: 'mdi-pencil-box',
                click: (event) => this.showDetails(event)
              }
            ],
            filtersConfig: {
              fields: [
                {
                  key: 'foreign_code',
                  label: this.$t('road-maintenance/aggregator.request_id')
                },
                {
                  key: 'reg',
                  label: this.$t('road-maintenance/aggregator.registration_time')
                },
                {
                  key: 'source',
                  label: this.$t('road-maintenance/aggregator.source')
                }
              ]
            }
          }
        },
        split: {
          children: [
            {
              component: this.mainTableMapComponent,
              useMapSizeSwitcher: false,
              googleMapConfig: {
                style: {
                  borderBottomLeftRadius: 'unset !important',
                  borderBottomRightRadius: 'unset !important'
                }
              },
              paneStyle: {
                borderBottomLeftRadius: 'unset !important',
                borderBottomRightRadius: 'unset !important'
              }
            }
          ]
        },
        breadcrumbs: {
          items: [
            {
              text: this.$t('road-maintenance.aggregator')
            },
            {
              text: this.$t('road-maintenance.road_information'),
              bolded: true
            }
          ]
        }
      }
    }
  },

  methods: {
    showDetails (event) {
      const { data } = event || {}
      const { id, request_type: requestType } = data || {}

      this.$router.push({
        name: 'Aggregator_road_information_details',
        params: {
          id: id
        },
        query: {
          category: 'request_overview',
          request_type: requestType?.name ?? ''
        }
      }).then()
    },

    onNewClick () {
      this.$router.push({
        name: 'Aggregator_road_information_details',
        query: {
          category: 'request_new'
        }
      }).then()
    }
  }
}
